// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2DpmV","footer":"ModalCreateQualiphyProcedure_footer__27Yu-","additionData":"ModalCreateQualiphyProcedure_additionData__y1z-8"};